import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DateRangeEventService {
  private eventSubject = new Subject<any>();

  notify(data: any) {
    this.eventSubject.next(data);
  }

  onDateRangeChanged() {
    return this.eventSubject.asObservable();
  }
}
